import React from 'react';
import PropTypes from 'prop-types';

/* Main Icons */
import AdEquiv from './icons/AdEquiv';
import Add from './icons/Add';
import AddCircle from './icons/AddCircle';
import AddDocument from './icons/AddDocument';
import AddToGroup from './icons/AddToGroup';
import ArrowBack from './icons/ArrowBack';
import ArrowDown from './icons/ArrowDown';
import ArrowDropDown from './icons/ArrowDropDown';
import ArrowDropUp from './icons/ArrowDropUp';
import ArrowForward from './icons/ArrowForward';
import ArrowLeft from './icons/ArrowLeft';
import ArrowRight from './icons/ArrowRight';
import ArrowUp from './icons/ArrowUp';
import Attach from './icons/Attach';
import Bell from './icons/Bell';
import Blocked from './icons/Blocked';
import Blog from './icons/Blog';
import Bolt from './icons/Bolt';
import Bookmark from './icons/Bookmark';
import Business from './icons/Business';
import Calendar from './icons/Calendar';
import Campaign from './icons/Campaign';
import ChartArea from './icons/ChartArea';
import ChartBarsHorz from './icons/ChartBarsHorz';
import ChartBarsStacked from './icons/ChartBarsStacked';
import ChartBarsVert from './icons/ChartBarsVert';
import ChartBarsBorder from './icons/ChartBarsBorder';
import ChartBubble from './icons/ChartBubble';
import ChartDonut from './icons/ChartDonut';
import ChartPie from './icons/ChartPie';
import ChartSparkAndBar from './icons/ChartSparkAndBar';
import ChartSparkline from './icons/ChartSparkline';
import Chat from './icons/Chat';
import Check from './icons/Check';
import Chevron from './icons/Chevron';
import ChevronLeft from './icons/ChevronLeft';
import ChevronRight from './icons/ChevronRight';
import ChevronUp from './icons/ChevronUp';
import Clear from './icons/Clear';
import Clock from './icons/Clock';
import Close from './icons/Close';
import Coffee from './icons/Coffee';
import ContactList from './icons/ContactList';
import Copy from './icons/Copy';
import Dashboard from './icons/Dashboard';
import Delete from './icons/Delete';
import Download from './icons/Download';
import Dinner from './icons/Dinner';
import Drinks from './icons/Drinks';
import Edit from './icons/Edit';
import EllipsisV from './icons/EllipsisV';
import Enlarge from './icons/Enlarge';
import Filter from './icons/Filter';
import Flag from './icons/Flag';
import Folder from './icons/Folder';
import FolderOpen from './icons/FolderOpen';
import FormatBold from './icons/FormatBold';
import FormatBulletNumbered from './icons/FormatBulletNumbered';
import FormatBulletPlain from './icons/FormatBulletPlain';
import FormatClear from './icons/FormatClear';
import FormatCode from './icons/FormatCode';
import FormatItalic from './icons/FormatItalic';
import FormatParagraphCenter from './icons/FormatParagraphCenter';
import FormatParagraphJustify from './icons/FormatParagraphJustify';
import FormatParagraphLeft from './icons/FormatParagraphLeft';
import FormatParagraphRight from './icons/FormatParagraphRight';
import Paper from './icons/Paper';
import FormattingTextColor from './icons/FormattingTextColor';
import FormattingText from './icons/FormattingText';
import FormattingUnderline from './icons/FormattingUnderline';
import Globe from './icons/Globe';
import GripperCorner from './icons/GripperCorner';
import Gripper from './icons/Gripper';
import Hamburger from './icons/Hamburger';
import Hide from './icons/Hide';
import Home from './icons/Home';
import Hyperlink from './icons/Hyperlink';
import Image from './icons/Image';
import Inbox from './icons/Inbox';
import Info2 from './icons/Info2';
import Info from './icons/Info';
import Kebabs from './icons/Kebabs';
import KeyMessage from './icons/KeyMessage';
import Key from './icons/Key';
import Lightning from './icons/Lightning';
import ListAdd from './icons/ListAdd';
import ListAlt from './icons/ListAlt';
import ListVerfied from './icons/ListVerfied';
import ListViewActive from './icons/ListViewActive';
import Location from './icons/Location';
import Lock from './icons/Lock';
import Lunch from './icons/Lunch';
import Magazine from './icons/Magazine';
import MailArchive from './icons/MailArchive';
import MailBulk from './icons/MailBulk';
import MailDraft from './icons/MailDraft';
import MailPersonal from './icons/MailPersonal';
import Mail from './icons/Mail';
import MarkAsUnread from './icons/MarkAsUnread';
import Meatballs from './icons/Meatballs';
import MediaList from './icons/MediaList';
import MentionGroup from './icons/MentionGroup';
import MessageBubble from './icons/MessageBubble';
import Mouse from './icons/Mouse';
import MoveToInbox from './icons/MoveToInbox';
import Move from './icons/Move';
import NewTab from './icons/NewTab';
import News from './icons/News';
import Note from './icons/Note';
import Numbers from './icons/Numbers';
import Phone from './icons/Phone';
import Pin from './icons/Pin';
import PitchStage from './icons/PitchStage';
import Play from './icons/Play';
import Refresh from './icons/Refresh';
import ReplyAll from './icons/ReplyAll';
import Reply from './icons/Reply';
import Report from './icons/Report';
import Restore from './icons/Restore';
import Search from './icons/Search';
import Send from './icons/Send';
import SentimentNegative from './icons/SentimentNegative';
import SentimentPositive from './icons/SentimentPositive';
import SentimentVeryNegative from './icons/SentimentVeryNegative';
import SentimentVeryPositive from './icons/SentimentVeryPositive';
import Sentiment from './icons/Sentiment';
import SettingsGear from './icons/SettingsGear';
import Share2 from './icons/Share2';
import ShareWith from './icons/ShareWith';
import Shared from './icons/Shared';
import Smartphone from './icons/Smartphone';
import SortAsc from './icons/SortAsc';
import SortDesc from './icons/SortDesc';
import SpikeAlert from './icons/SpikeAlert';
import StarEmpty from './icons/StarEmpty';
import StarFilled from './icons/StarFilled';
import Station from './icons/Station';
import SyncDisabled from './icons/SyncDisabled';
import SyncError from './icons/SyncError';
import Sync from './icons/Sync';
import Tag from './icons/Tag';
import ThumbsUp from './icons/ThumbsUp';
import TimerOff from './icons/TimerOff';
import Timer from './icons/Timer';
import Tv from './icons/Tv';
import Upload from './icons/Upload';
import UserRelationship from './icons/UserRelationship';
import User from './icons/User';
import UserEmpty from './icons/UserEmpty';
import ViewGrid from './icons/ViewGrid';
import ViewStream from './icons/ViewStream';
import ViewTable from './icons/ViewTable';
import ViewVerticalSplit from './icons/ViewVerticalSplit';
import View from './icons/View';
import Warning from './icons/Warning';
import Web from './icons/Web';
import Work from './icons/Work';
/** ICON_INJECTOR */

/* Logo Icons */
import Exchange from './icons/Exchange';
import Facebook from './icons/Facebook';
import Google from './icons/Google';
import GooglePlus from './icons/GooglePlus';
import Instagram from './icons/Instagram';
import LinkedIn from './icons/LinkedIn';
import Outlook from './icons/Outlook';
import Pinterest from './icons/Pinterest';
import Reddit from './icons/Reddit';
import Slack from './icons/Slack';
import Twitch from './icons/Twitch';
import Twitter from './icons/Twitter';
import YouTube from './icons/YouTube';
/* Twitter Icons*/
import Retweet from './icons/Retweet';
import TwitterComment from './icons/TwitterComment';
import TwitterEmail from './icons/TwitterEmail';
import TwitterLike from './icons/TwitterLike';
import TwitterVerified from './icons/TwitterVerified';
import VerificationBadge from './icons/VerificationBadge';

export const iconsMap = {
  'ad-equiv': AdEquiv,
  add: Add,
  'add-circle': AddCircle,
  'add-Paper': AddDocument,
  'add-to-group': AddToGroup,
  'arrow-back': ArrowBack,
  'arrow-down': ArrowDown,
  'arrow-drop-down': ArrowDropDown,
  'arrow-drop-up': ArrowDropUp,
  'arrow-forward': ArrowForward,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  attach: Attach,
  bell: Bell,
  blocked: Blocked,
  blog: Blog,
  bolt: Bolt,
  bookmark: Bookmark,
  business: Business,
  calendar: Calendar,
  campaign: Campaign,
  'chart-area': ChartArea,
  'chart-bars-border': ChartBarsBorder,
  'chart-bars-horz': ChartBarsHorz,
  'chart-bars-stacked': ChartBarsStacked,
  'chart-bars-vert': ChartBarsVert,
  'chart-bubble': ChartBubble,
  'chart-donut': ChartDonut,
  'chart-pie': ChartPie,
  'chart-spark-and-bar': ChartSparkAndBar,
  'chart-sparkline': ChartSparkline,
  chat: Chat,
  check: Check,
  'chevron-down': Chevron,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clear: Clear,
  'times-circle': Clear, // for backwards compatibility
  clock: Clock,
  close: Close,
  coffee: Coffee,
  'contact-list': ContactList,
  copy: Copy,
  dashbord: Dashboard,
  delete: Delete,
  trash: Delete, // for backwards compatibility
  dinner: Dinner,
  drinks: Drinks,
  download: Download,
  edit: Edit,
  'ellipsis-v': EllipsisV,
  enlarge: Enlarge,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  'folder-open': FolderOpen,
  'format-bold': FormatBold,
  'format-bullet-numbered': FormatBulletNumbered,
  'format-bullet-plain': FormatBulletPlain,
  'format-clear': FormatClear,
  'format-code': FormatCode,
  'format-italic': FormatItalic,
  'format-paragraph-center': FormatParagraphCenter,
  'format-paragraph-justify': FormatParagraphJustify,
  'format-paragraph-left': FormatParagraphLeft,
  'format-paragraph-right': FormatParagraphRight,
  'formatting-text-color': FormattingTextColor,
  'formatting-text': FormattingText,
  'formatting-underline': FormattingUnderline,
  globe: Globe,
  'gripper-corner': GripperCorner,
  gripper: Gripper,
  hamburger: Hamburger,
  hide: Hide,
  home: Home,
  hyperlink: Hyperlink,
  image: Image,
  inbox: Inbox,
  'info-2': Info2,
  info: Info,
  kebabs: Kebabs,
  'key-message': KeyMessage,
  key: Key,
  lightning: Lightning,
  'list-add': ListAdd,
  'list-alt': ListAlt,
  'list-verfied': ListVerfied,
  'list-view-active': ListViewActive,
  location: Location,
  lock: Lock,
  lunch: Lunch,
  magazine: Magazine,
  'mail-archive': MailArchive,
  'mail-bulk': MailBulk,
  'mail-draft': MailDraft,
  'mail-personal': MailPersonal,
  mail: Mail,
  'mark-as-unread': MarkAsUnread,
  meatballs: Meatballs,
  'media-list': MediaList,
  'mention-group': MentionGroup,
  'message-bubble': MessageBubble,
  mouse: Mouse,
  'move-to-inbox': MoveToInbox,
  move: Move,
  'new-tab': NewTab,
  news: News,
  note: Note,
  numbers: Numbers,
  paper: Paper,
  phone: Phone,
  pin: Pin,
  'pitch-stage': PitchStage,
  play: Play,
  refresh: Refresh,
  'reply-all': ReplyAll,
  reply: Reply,
  report: Report,
  restore: Restore,
  search: Search,
  send: Send,
  'sentiment-negative': SentimentNegative,
  'sentiment-positive': SentimentPositive,
  'sentiment-very-negative': SentimentVeryNegative,
  'sentiment-very-positive': SentimentVeryPositive,
  sentiment: Sentiment,
  'settings-gear': SettingsGear,
  'share-2': Share2,
  'share-with': ShareWith,
  shared: Shared,
  smartphone: Smartphone,
  'sort-asc': SortAsc,
  'sort-desc': SortDesc,
  'spike-alert': SpikeAlert,
  'star-empty': StarEmpty,
  'star-filled': StarFilled,
  station: Station,
  'sync-disabled': SyncDisabled,
  'sync-error': SyncError,
  sync: Sync,
  tag: Tag,
  'thumbs-up': ThumbsUp,
  'timer-off': TimerOff,
  timer: Timer,
  tv: Tv,
  upload: Upload,
  'user-relationship': UserRelationship,
  user: User,
  'user-empty': UserEmpty,
  'view-grid': ViewGrid,
  'view-stream': ViewStream,
  'view-table': ViewTable,
  'view-vertical-split': ViewVerticalSplit,
  view: View,
  warning: Warning,
  web: Web,
  work: Work,
  facebook: Facebook,
  instagram: Instagram,
  linkedin: LinkedIn,
  reddit: Reddit,
  twitch: Twitch,
  twitter: Twitter,
  youtube: YouTube,
  exchange: Exchange,
  google: Google,
  googleplus: GooglePlus,
  outlook: Outlook,
  slack: Slack,
  pinterest: Pinterest,
  retweet: Retweet,
  'twitter-comment': TwitterComment,
  'twitter-email': TwitterEmail,
  'twitter-like': TwitterLike,
  'twitter-verified': TwitterVerified,
  'verification-badge': VerificationBadge,
  /* NAME_INJECTOR */
};

const Icon = ({ name, ...passedProps }) =>
  iconsMap[name] ? React.createElement(iconsMap[name], passedProps) : null;

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
